import { DEFAULT_BENEFIT } from "src/constants/stats";
import { InsuranceKeyProps, CaseDetailProps as InsuranceProps } from "../components/manufacturer/stepperModal/types";


export const calculateDrugValueBasedOnParams = (drugFromParam: string | null): string => {
  if (!drugFromParam) return "";

  if (drugFromParam.toLowerCase().includes("product")) return ""
  else if (drugFromParam.toLowerCase() === "iovera") return "iovera°"
  else return drugFromParam
}

export const doesBenefitHasInOrOutNetwork = (insurance_data: InsuranceProps): string => {
  const { in_network_tab, out_network_tab } = insurance_data;
  const isInNetworkUpdated = Object.keys(in_network_tab).map((key: unknown) => {
    return DEFAULT_BENEFIT[key as InsuranceKeyProps] !== in_network_tab[key as InsuranceKeyProps].trim()
  })

  const isOutNetworkUpdated = Object.keys(out_network_tab).map((key: unknown) => {
    return DEFAULT_BENEFIT[key as InsuranceKeyProps] !== out_network_tab[key as InsuranceKeyProps].trim()
  })

  if (isInNetworkUpdated) return "in_network"
  else if (isOutNetworkUpdated) return "out_network"
  else return ""
}
